<template>
    <i class="pi pi-question-circle" :class="{'cursor-pointer': link}" :title="text" @click="onClick"></i>
</template>

<script>
export default {
    name: "AdaptersHelpInfo",
    props: {
        text: {
            type: String,
            required: false,
            default: null,
        },
        link: {
            type: String,
            required: false,
            default: null,
        }
    },
    methods: {
        onClick() {
            if (this.link) {
                window.open(this.link, '_blank');
            }
        }
    }
}
</script>

<style scoped>
i {
    color: var(--gray-500);
    margin-left: 0.625rem;
}
</style>
